(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("no-data-reprojection", [], factory);
	else if(typeof exports === 'object')
		exports["no-data-reprojection"] = factory();
	else
		root["no-data-reprojection"] = factory();
})(self, function() {
return 